import React from "react";
import "../main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../plugins.min.css";
import Factsheet from "./Factsheet";
import HowToHire from "../HowToHire"
import ExpertiseE from "./ExpertiseE";

function Banner1() {
  return (
    <div>
      <div class="parallax services-top-main" id="parallax">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="text-left mauto">
                <div class="home-slider-decor mobile-about-img">
                <img class="" loading="lazyload" data-src="img/website-service-img.png" src="img/website-service-img.png" alt="Top Website Development Services" title="Top Website Development Services" width="620" height="490"/>
              </div>
                <h1 data-aos="Fade-in" class="section-title mb-30">Hire Full-Stack Development Team</h1>
                <p>Are you looking to develop a website or a mobile application? We at iCoderz Solutions offer you a full-stack web and mobile application development team to accomplish your project. Be it any web/mobile development framework; we have got the most experienced team to work for you!</p>
                {/* <p>Consult with our Business Head and let's start developing next-gen MVP Website for your upcoming/existing startup or brand.</p> */}
                <div className="d-inline ml-0 ml-lg-3 my-2 my-lg-0">
                  <a className=" butn butn-sm" href="#">
                    Let's talk
                  </a>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 desktop-about-img">
              <div class="home-slider-decor">
              <img class="" loading="lazyload" data-src="img/website-service-img.png" src="img/website-service-img.png" alt="Top Website Development Services" title="Top Website Development Services" width="620" height="490"/>
             </div> 
            </div> 
          </div>
        </div>
      </div>

      <Factsheet />

      {/* <div class="parallax services-top-main" id="parallax">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="text-left mauto">
                <div class="home-slider-decor mobile-about-img">
                <img class="" loading="lazyload" data-src="img/hire-full-stack.png" src="img/hire-full-stack.png" alt="Hire Full-stack Developers" title="Hire Full-stack Developers" width="512" height="512"/>
                </div>
                <h1>Enterprise Software Development</h1>
                 <p>A full-stack mobile and web app development means developing a native or a hybrid application for the client from the back-end, middleware to the front-end. It involves a complete set of development of any web or mobile application.</p>
                <p>Our developers hold expertise in the various mobile application development frameworks. IOS app development, Android app development, hybrid app development, flutter app development, swift app development or react-native app development, we have got the best mobile app development team for you! Likewise, our website development expertise includes WordPress, Laravel, PHP, and other website development frameworks.</p>
                <p>Hiring our full-stack developers will fasten your web or mobile app development project. Our full-stack app developers hold an average experience of 3.5 years.</p> 
                <div className="d-inline ml-0 ml-lg-3 my-2 my-lg-0">
                  <a className=" butn butn-sm" href="#">
                    Let's talk
                  </a>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 desktop-about-img">
              <div class="home-slider-decor">
              <img class="" loading="lazyload" data-src="img/hire-full-stack.png" src="img/hire-full-stack.png" alt="Hire Full-stack Developers" title="Hire Full-stack Developers" width="512" height="512"/>
             </div> 
            </div> 
          </div>
        </div>
      </div> */}


<ExpertiseE/>   
{/* <HowToHire/> */}
      {/* <div class="parallax let-us ios-about-main">
        <div class="container">
          <div class="row">
            <div class="col-lg-7 col-md-12 text-left">
              <div class="soln-heading">
              <h2>What Is The Minimum Viable Product (MVP)?</h2>
              </div>
              <div class="ios-about-con">
                <div class="ios-img-box mobile-about-img">
                  <img
                    class=""
                    loading="lazyload"
                    data-src="img/ios-main-img.png"
                    src="img/ios-main-img.png"
                    alt="HR"
                    title="HR"
                  />
                </div>
                <div class="ios-small-img-box mobile-about-img">
                  <img
                    class=""
                    loading="lazyload"
                    data-src="img/os-sub-img.png"
                    src="img/os-sub-img.png"
                    alt="Management Team"
                    title="Management Team"
                  />
                </div>
                <p>Peak performance of Websites and Web Applications developed using NODEJS leads to the better user experience. 'iCoderz Solutions' has a specialized team of <a class="internal-links" href="#">NODEJS</a> developers for dedicated development of your websites. Our expert developers can develop all types of websites and web applications.</p>
                <p>Our expert developers can develop all types of single-page applications, websites, and cross- platform applications. We offer holistic capabilities and full-stack technological expertise for all the platforms and website development services to satisfy your business needs and help you grow your business.</p>
                <p>Let us come together for building excellent AngularJS webpages for your business.</p>
                <h5>Celebrating a decade in developing Awesome Website</h5>
                <div class="row">
                <div class="col-lg-2 col-md-3 col-sm-6 col-6">
<div class="app-ics">
<img class="" loading="lazyload" data-src="img/ms-ecommarce-y.svg" src="img/ms-ecommarce-y.svg" alt="eCommerce" title="eCommerce"/>
<p>eCommerce</p>
</div>
</div>
    <div class="col-lg-2 col-md-3 col-sm-6 col-6">
<div class="app-ics">
<img class="" loading="lazyload" data-src="img/s-businss.svg" src="img/s-businss.svg" alt="Business" title="Business"/>

<p>Business</p>
</div>
</div>

<div class="col-lg-2 col-md-3 col-sm-6 col-6">
<div class="app-ics">
<img class="" loading="lazyload" data-src="img/s-personal.svg" src="img/s-personal.svg" alt="Personal" title="Personal"/>
<p>Personal</p>
</div>
</div>

<div class="col-lg-2 col-md-3 col-sm-6 col-6">
<div class="app-ics">
<img class="" loading="lazyload" data-src="img/s-theme-bs.svg" src="img/s-theme-bs.svg" alt="Theme-Based" title="Theme-Based"/>
<p>Theme-Based</p>
</div>
</div>



                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-12 ios-right-img desktop-about-img">
              <div class="ios-img-box">
                <img
                  class=""
                  loading="lazyload"
                  data-src="img/ios-main-img.png"
                  src="img/ios-main-img.png"
                  alt="HR"
                  title="HR"
                />
              </div>
              <div class="ios-small-img-box">
                <img
                  class=""
                  loading="lazyload"
                  data-src="img/os-sub-img.png"
                  src="img/os-sub-img.png"
                  alt="Management Team"
                  title="Management Team"
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Banner1;
